import { Button } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRootStore } from 'store/rootStore';
import { useHistory } from 'react-router-dom';
import { ProposalAction } from 'types/enrollmentService';
import { ProposalConfirmationStatus } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import { createStyles } from './styles';

const EmployerProposalPageFooter = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    proposalItemsStore: { confirmProposalEnabled, proposalConfirmationStatus, enrollmentPeriod, confirmProposal },
  } = useRootStore();

  // Common data
  const history = useHistory();

  // Component actions
  function redirect(url: string): void {
    history.push(url);
  }

  const onNewConfirm = async (): Promise<void> => {
    await confirmProposal(ProposalAction.CONFIRM, true);
    redirect(`/checklist/${enrollmentPeriod.id}`);
  };

  const onSaveAndExit = async (): Promise<void> => {
    await confirmProposal(undefined, false);
    redirect(`/group/${enrollmentPeriod.groupId}`);
  };

  const FooterLayout = (): JSX.Element => {
    switch (proposalConfirmationStatus) {
      case ProposalConfirmationStatus.NEW:
        return (
          <>
            <Button size="large" type="outlined" onClick={onSaveAndExit} className={classes.saveButton}>
              Save and Exit
            </Button>
            {confirmProposalEnabled ? (
              <Button size="large" color="primary" onClick={onNewConfirm}>
                Confirm
              </Button>
            ) : (
              <Button size="large" disabled>
                Confirm
              </Button>
            )}
          </>
        );

      default:
        return (
          <Button
            size="large"
            type="outlined"
            width="24rem"
            onClick={(): void => {
              history.goBack();
            }}
            className={classes.saveButton}
          >
            Exit
          </Button>
        );
    }
  };

  return <footer className={classes.footer}>{FooterLayout()}</footer>;
});

export default EmployerProposalPageFooter;
